import { render, staticRenderFns } from "./newAnalysis.vue?vue&type=template&id=21d2f249&scoped=true&"
import script from "./newAnalysis.vue?vue&type=script&lang=js&"
export * from "./newAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./newAnalysis.vue?vue&type=style&index=0&id=21d2f249&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d2f249",
  null
  
)

export default component.exports